import { select } from 'redux-saga/effects';
import api from 'services';

// eslint-disable-next-line import/prefer-default-export
export function* refNumber(response) {
    const store = yield select();
    let refNo;
    if (response.clientRefNo) {
        refNo = response.clientRefNo;
    } else {
        refNo = response.refNo;
    }

    api.sendRefNumber(store.letter._id, { refNo, requestId: response.id });
}



// WEBPACK FOOTER //
// ./app/sagas/refNumber.js